import React from "react";
import { useSelector } from "react-redux";
import { PropTypes } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";

import { useStateValue } from "../../SharedContext";
import { getTextColor, getSlug } from "../../../utils/utils";
import CircleIcon from "../../../../components/atoms/Circle";

import "./collection-name.m.css";

export const CollectionName = ({
  collection,
  headerLevel,
  customCollectionName = "",
  navigate = true,
  customSlug,
  showCircleIcon,
}) => {
  const config = useSelector((state) => get(state, ["qt", "config"], {}));
  const collectionTitle = useStateValue() || {};
  const showRowTitle = get(collectionTitle, ["showRowTitle"], true);
  const slug = customSlug || (navigate && collection && getSlug(collection, config)) || "";
  const collectionName = customCollectionName || collection.name || "";
  const textColor = getTextColor(collectionTitle.theme);
  const HeaderTag = "h" + headerLevel;

  return (
    <>
      {showRowTitle && collectionName && (
        <div
          className="arr--collection-name arrow-component"
          styleName={`collection ${textColor}`}
          data-test-id="collection-name"
        >
          {showCircleIcon && <CircleIcon />}
          {slug && !slug.includes(undefined) ? (
            <Link href={slug} aria-label="collection-name" disableAjaxLinks={true}>
              <HeaderTag>{collectionName}</HeaderTag>
            </Link>
          ) : (
            <HeaderTag>{collectionName}</HeaderTag>
          )}
        </div>
      )}
    </>
  );
};

CollectionName.propTypes = {
  collection: PropTypes.object,
  headerLevel: PropTypes.string,
  customCollectionName: PropTypes.string,
  navigate: PropTypes.bool,
  showCircleIcon: PropTypes.bool,
};

CollectionName.defaultProps = {
  headerLevel: "3",
  showCircleIcon: true,
};
